import React from 'react';

import CommonImage from '@/components/CommonImage';

const ProjectView = () => {
	return (
		<div className="body-content task-contetn bg-white">
			{/* <div className="top-header bg-white">
				<div className="d-flex align-items-center justify-content-between">
					<div className="top-header-left">
						<p className="medium-14 gray_dark_02 weight-500">22 Project</p>
					</div>
					<div className="top-header-right">
						<div class="filter-actions compare-filter-actions">
							<div class="form-group size32 m-0 mr-1 search-filter filter-with-animation">
								<div class="with-icon right-icon hidden">
									<input type="text" placeholder="Search" />
									<span class="right-icon">
										<CommonImage src="/icons/search.png" />
									</span>
								</div>
							</div>
							<div class="add-new-task">
								<button class="button text size32 px-0">
									<CommonImage src="icons/add-round.svg" />
									<span class="ml-1 gray_dark_01">Project</span>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div> */}
			<div className="task-list-container project-list-container">
				<div className="task-all-row d-grid gap-5 grid-columns-4">
					<div className="task-column project-column">
						<div className="project-column-header mb-3 d-flex align-items-center justify-content-center">
							<CommonImage src="/images/trend/zalando.png" />
						</div>
						<div className="project-column-body">
							<div className="single-project-box active-collapse mb-2">
								<div className="box-header">
									<p className="gray_dark_01 regular-16 weight-600">RUNNING(10)</p>
								</div>
								<div className="box-content mt-12">
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
								</div>
								<div className="view-more d-flex align-items-center cursor-pointer">
									<p className="gray_dark_01 regular-14 weight-400 pb-1 mr-1">
										View <span>4</span> more
									</p>
									<CommonImage
										className="arrow-icon"
										src="/icons/down-arrow-gray-dark-01.svg"
										width={20}
										height={20}
									/>
								</div>
							</div>
							<div className="single-project-box">
								<div className="box-header">
									<p className="gray_dark_01 regular-16 weight-600">NOT STARTED(10)</p>
								</div>
								<div className="box-content mt-12">
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
								</div>
								<div className="view-more d-flex align-items-center cursor-pointer">
									<p className="gray_dark_01 regular-14 weight-400 pb-1 mr-1">
										View <span>4</span> more
									</p>
									<CommonImage
										className="arrow-icon"
										src="/icons/down-arrow-gray-dark-01.svg"
										width={20}
										height={20}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="task-column project-column">
						<div className="project-column-header mb-3 d-flex align-items-center justify-content-center">
							<CommonImage src="/images/trend/zalando.png" />
						</div>
						<div className="project-column-body">
							<div className="single-project-box active-collapse mb-2">
								<div className="box-header">
									<p className="gray_dark_01 regular-16 weight-600">RUNNING(10)</p>
								</div>
								<div className="box-content mt-12">
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
								</div>
								<div className="view-more d-flex align-items-center cursor-pointer">
									<p className="gray_dark_01 regular-14 weight-400 pb-1 mr-1">
										View <span>4</span> more
									</p>
									<CommonImage
										className="arrow-icon"
										src="/icons/down-arrow-gray-dark-01.svg"
										width={20}
										height={20}
									/>
								</div>
							</div>
							<div className="single-project-box">
								<div className="box-header">
									<p className="gray_dark_01 regular-16 weight-600">NOT STARTED(10)</p>
								</div>
								<div className="box-content mt-12">
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
									<p className="gray_dark_02 regular-14 weight-400 cursor-pointer pb-1">
										Create and collaborate (C&C) (3)
									</p>
								</div>
								<div className="view-more d-flex align-items-center cursor-pointer">
									<p className="gray_dark_01 regular-14 weight-400 pb-1 mr-1">
										View <span>4</span> more
									</p>
									<CommonImage
										className="arrow-icon"
										src="/icons/down-arrow-gray-dark-01.svg"
										width={20}
										height={20}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="task-column project-column">
						<div className="project-column-header mb-3 d-flex align-items-center justify-content-center">
							<CommonImage src="/images/trend/zalando.png" />
						</div>
						<div className="project-column-body">
							<div className="single-project-box active-collapse mb-2">
								<div className="box-header">
									<p className="gray_dark_01 regular-16 weight-600">RUNNING(10)</p>
								</div>
								<div className="box-content mt-12">
									<div className="single-list pb-2 position-relative">
										<div className="d-flex align-items-center justify-content-start">
											<p className="gray_dark_01 regular-14 weight-400">
												Pick and choose (P&amp;C) (2)
											</p>
											<img
												src="/icons/down-arrow-gray-dark-02.svg"
												alt="arrow"
												className=""
												width="20"
												height="20"
												loading="lazy"
											/>
										</div>
										<div className="project-list-popup position-absolute shadow-8dp scroll-y-label">
											<p className="view-more d-flex align-items-center cursor-pointer">
												<span className="gray_dark_01 regular-14 weight-400 cursor-pointer">
													View all
												</span>
											</p>
											<p>
												<span className="gray_dark_01 regular-14 weight-400 cursor-pointer mr-1">
													100%
												</span>
												<span className="mr-1">|</span>
												<span className="gray_dark_01 regular-14 weight-400 cursor-pointer mr-1">
													Medium
												</span>
												<span className="mr-1">|</span>
												<span className="gray_dark_01 regular-14 weight-400 cursor-pointer mr-1">
													dfdfd
												</span>
											</p>
										</div>
									</div>
								</div>
								<div className="view-more d-flex align-items-center cursor-pointer">
									<p className="gray_dark_01 regular-14 weight-400 pb-1 mr-1">
										View <span>4</span> more
									</p>
									<CommonImage
										className="arrow-icon"
										src="/icons/down-arrow-gray-dark-01.svg"
										width={20}
										height={20}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProjectView;
